import { useEffect, useRef, useState } from 'react';

export function useScrollHeader(menuOpen: boolean) {
  const ref = useRef<HTMLElement>(null);
  const [height, setHeight] = useState(0);
  const [floating, setFloating] = useState(false);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const measure = () => setHeight(element.getBoundingClientRect().height);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let anchor = Math.max(0, window.scrollY);
    let frame = 0;
    const update = () => {
      frame = 0;
      const y = Math.max(0, window.scrollY);
      const detached = y > height;
      setFloating(detached);
      if (!detached) {
        setVisible(true);
        anchor = y;
      } else if (Math.abs(y - anchor) >= 12) {
        setVisible(y < anchor);
        anchor = y;
      }
    };
    const onScroll = () => { if (!frame) frame = window.requestAnimationFrame(update); };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('hashchange', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('hashchange', onScroll);
      window.cancelAnimationFrame(frame);
    };
  }, [height]);

  return { ref, height, floating, visible: visible || menuOpen };
}

